"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackField = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FeedbackField = ({
  addItemTitle,
  feedbackItemStartIcon,
  helperText,
  placeholder,
  name,
  removeItemTitle,
  title,
  testId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const feedback = (0, _contexts.useRatingAndReviewWatch)(name);
  const {
    items,
    inputValue
  } = feedback;
  const {
    setValue
  } = (0, _contexts.useRatingAndReviewForm)();
  const addButtonDisabled = !inputValue.trim() || items.includes(inputValue.trim());
  const slotProps = (0, _react.useMemo)(() => ({
    htmlInput: {
      [_constants.DATA_TEST_ID]: getTestId(_constants2.FEEDBACK_FIELD_INPUT)
    }
  }), [getTestId]);
  const onInputChange = (0, _react.useCallback)(e => {
    setValue(name, {
      items,
      inputValue: e.target.value
    });
  }, [setValue, name, items]);
  const onAddClick = (0, _react.useCallback)(() => {
    const value = inputValue.trim();
    if (value && !items.includes(value)) {
      setValue(name, {
        items: [...items, value],
        inputValue: ''
      });
    }
  }, [items, inputValue, name, setValue]);
  const onInputKeyDown = (0, _react.useCallback)(e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onAddClick();
    }
  }, [onAddClick]);
  const onRemoveClick = (0, _react.useCallback)(item => () => {
    setValue(name, {
      items: items.filter(feedbackItem => feedbackItem !== item),
      inputValue
    });
  }, [items, inputValue, name, setValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    "data-testid": testId,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h5",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      display: "flex",
      gap: 3,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
        fullWidth: true,
        placeholder: placeholder,
        helperText: helperText,
        slotProps: slotProps,
        value: inputValue,
        onChange: onInputChange,
        onKeyDown: onInputKeyDown
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddIconButton, {
        "aria-label": addItemTitle,
        "data-testid": getTestId(_constants2.FEEDBACK_FIELD_ADD_ITEM_BUTTON),
        color: "secondary",
        variant: "contained",
        disabled: addButtonDisabled,
        onClick: onAddClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {})
      })]
    }), items.map(feedbackItem => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      "data-testid": getTestId(_constants2.FEEDBACK_FIELD_ITEM),
      display: "flex",
      alignItems: "center",
      gap: 1,
      children: [feedbackItemStartIcon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        fontSize: "1.6rem",
        children: feedbackItem
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.RemoveIconButton, {
        "aria-label": removeItemTitle,
        "data-testid": getTestId(_constants2.FEEDBACK_FIELD_REMOVE_ITEM_BUTTON),
        size: "small",
        variant: "text",
        onClick: onRemoveClick(feedbackItem),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Trashcan, {})
      })]
    }, feedbackItem))]
  });
};
exports.FeedbackField = FeedbackField;
